export { default } from '../components/pages/Photos';
